module.exports = __webpack_public_path__ + "static/surya-master-02-ac3ea5dcf0eb1e6b120aa17c47790870.png";